import { createQueryHook } from '@fourthwall/utils/dist/queries';
import { DonationApiClient } from '@fourthwall/services/dist/DonationApiClient';
export const useDonationQuery = createQueryHook(DonationApiClient.getDonation, {
    queryKey: ['donation'],
});
